<template>
  <div class="text-center">
    <div class="d-flex align-center mb-1" style="justify-content: space-evenly">
      <!-- Minus button -->
      <div>
        <v-btn
          fab
          x-small
          color="primary"
          elevation="3"
          :disabled="quantityOfNodeOutputs === 1"
          @click="removeOutput"
        >
          <v-icon>
            mdi-minus
          </v-icon>
        </v-btn>
      </div>

      {{ quantityOfNodeOutputs }}

      <!-- Plus button -->
      <div>
        <v-btn
          fab
          x-small
          color="primary"
          @click="addOutput"
        >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </div>
    </div>

    <span class="text--secondary">
      Outputs
    </span>
  </div>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'EditSplitterNode',
    props: {
      nodeId: {
        type: String,
        default: ''
      },
    },
    data: () => ({
      quantityOfNodeOutputs: null
    }),
    mounted () {
      const quantityOfNodeOutputs = store.getters.getQuantityOfNodeOutputsByNodeId(this.nodeId)
      this.quantityOfNodeOutputs = !quantityOfNodeOutputs ? 2 : quantityOfNodeOutputs
    },
    methods: {
      addOutput () {
        store.commit('ADD_OUTPUT_TO_SELECTED_NODE')
        this.quantityOfNodeOutputs++
      },
      removeOutput () {
        store.commit('REMOVE_OUTPUT_TO_SELECTED_NODE')
        this.quantityOfNodeOutputs--
      },
    }
  }
</script>

<style scoped>

</style>
